const STORAGE_CHAT_CONTROL = 'sfChatControl';

class ChatControl {
  constructor(localStorage) {
    this.localStorage = localStorage;
    this.data = {};
  }

  load = () => {
    const storedItem = this.localStorage.getItem(STORAGE_CHAT_CONTROL);
    this.data = JSON.parse(storedItem) || {};
  };

  clear = () => {
    this.localStorage.removeItem(STORAGE_CHAT_CONTROL);
    this.data = {};
  };

  update = (result, isBroadcast) => {
    Object.assign(this.data, JSON.parse(result.data));
    if (!isBroadcast) {
      localStorage.setItem(STORAGE_CHAT_CONTROL, JSON.stringify(this.data));
    }
  };

  get needsRating() {
    return !!this.data.needsRating;
  }

  get ratings() {
    return this.data.ratings || [];
  }

  get translations() {
    return this.data.translations || {};
  }

  get predictionAnswerHtml() {
    return this.data.predictionAnswerHtml;
  }

  setPredictionAnswerControl(control) {
    this.data.predictionAnswerControl = control;
    localStorage.setItem(STORAGE_CHAT_CONTROL, JSON.stringify(this.data));
  }

  get predictionAnswerControl() {
    return this.data.predictionAnswerControl;
  }

  get termsAndConditionsHtml() {
    return this.data.termsAndConditionsHtml;
  }

  get termsAndConditionsControl() {
    return this.data.termsAndConditionsControl;
  }

  setTermsAndConditionsControl(control) {
    this.data.termsAndConditionsControl = control;
    localStorage.setItem(STORAGE_CHAT_CONTROL, JSON.stringify(this.data));
  }
}

export default ChatControl;
